import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Flex, Form, Image, Row, Table, Typography, Space } from 'antd'
import { ActionButton, AlertModal, ModuleTopHeading, ReviewView, SearchInput } from '../../components';
import { reviewData } from '../../Data';
import { useDispatch, useSelector } from 'react-redux';
import { actionsApi, TableLoader } from '../../shared';
import { apiCalls } from '../../shared/Apis';

let timer;
const { Text } = Typography
const ReviewPage = () => {

    const [form] = Form.useForm();
    const [deleteitem,setDeleteItem] = useState(false)
    const [ visible, setVisible ] = useState(false)
    const [ view, setView ] = useState(null)
    const [ deletionLoading, setDeletionLoading]= useState(false)
    const dispatch = useDispatch()
    const { reviewData, loadingrev, filters, pagination } = useSelector(state => state?.Reviewapi)

    useEffect(()=>{
        dispatch(actionsApi?.getReviewsAll({...filters, ...pagination, pageNo: 1}))
    },[])

    const call = (pageNo=1, pageSize=10)=> {
        dispatch(actionsApi?.getReviewsAll({...filters, pageNo, pageSize}))
    }

     function searchHandler(name, pageNo=1, pageSize=20) {
        dispatch(actionsApi?.getReviewsAll({ ...filters, name, pageNo, pageSize }))
    }

    function debounce(func, delay) {
        return function(...args) {
            clearTimeout(timer)
            timer = setTimeout(() => {
                func.apply(this, args)
            }, delay)
        };
    }
    const debouncedSearchHandler = debounce(searchHandler, 400)

    const columns = [
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Professional Name</Text>,
            dataIndex: 'proName',
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Client Name</Text>,
            dataIndex: 'clientName',
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Professional Reviews</Text>,
            dataIndex: 'proReview',
            render:(proReview) => {
                if(proReview === 1){
                    return (
                        <Space size={2}>
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                        </Space>
                    )
                } else if(proReview === 2){
                    return (
                        <Space size={2}>
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                        </Space>
                    )
                } else if(proReview === 3){
                    return (
                        <Space size={2}>
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                        </Space>
                    )
                } else if(proReview === 4){
                    return (
                        <Space size={2}>
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                        </Space>
                    )
                } else{
                    return (
                        <Space size={2}>
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                        </Space>
                    )
                }
            }
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Client Reviews</Text>,
            dataIndex: 'clientReview',
            render:(clientReview) => {
                if(clientReview === 1){
                    return (
                        <Space size={2}>
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                        </Space>
                    )
                } else if(clientReview === 2){
                    return (
                        <Space size={2}>
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                        </Space>
                    )
                } else if(clientReview === 3){
                    return (
                        <Space size={2}>
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                        </Space>
                    )
                } else if(clientReview === 4){
                    return (
                        <Space size={2}>
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-e.png' width={15} />
                        </Space>
                    )
                } else{
                    return (
                        <Space size={2}>
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                            <img src='/assets/icons/star-f.png' width={15} />
                        </Space>
                    )
                }
            }
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Date</Text>,
            dataIndex: 'date'
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Action</Text>,
            key: 'action',
            fixed: 'right',
            width: 150,
            render: (_, row) => (
                <Space>
                    <ActionButton
                        title='Notification View'
                        shape="circle"
                        icon={<Image src='/assets/icons/view.png' width={18} preview={false} />}
                        className='border0 bg-transparent'
                        onClick={() => { setVisible(true); setView(row) }}
                    />
                    <ActionButton
                        title='Delete Item'
                        shape="circle"
                        icon={<Image src='/assets/icons/delete.png' width={18} preview={false} />}
                        className='border0 bg-transparent'
                        onClick={() => {setDeleteItem({name: row?.title, id: row?.id})}}
                    />
                </Space>
            ),
        },
    ];

    // delete job api
    const DeleteReviews= async ()=>{
        setDeletionLoading(true)
        let result= await apiCalls?.Reviewpostapi?.DeleteReviews(deleteitem?.id)
        if(result){
            setDeleteItem(null)
            searchHandler('')
        }
        setDeletionLoading(false)
    }

    return (
        <>
            <Card className='shadow-d radius-12'>
                <Row gutter={[24, 24]}>
                    <Col span={24}>
                        <Flex vertical gap={20}>
                            <ModuleTopHeading level={4} name='Reviews'/>
                            <Form
                                form={form}
                                layout="vertical"
                            >
                                <Row gutter={[16,16]} align={'middle'}>
                                    <Col lg={8} md={12} sm={24} xs={24}>
                                        <SearchInput 
                                            name='name'
                                            placeholder='Search'
                                            value={form.getFieldValue('name') || ''}
                                            prefix={<img src='/assets/icons/search.png' width={20} />}
                                            className='border-light-gray pad-x ps-0 radius-8 fs-13 search-w'
                                            onChange={(e)=> debouncedSearchHandler(e.target.value, 1,20)}
                                        />
                                    </Col>
                                </Row>
                            </Form>
                        </Flex>
                    </Col>
                    <Col span={24}>
                        <Table
                            size='large'
                            columns={columns}
                            dataSource={reviewData}
                            className='pagination'
                            showSorterTooltip={false}
                            scroll={{ x: 1200 }}
                            pagination={{
                                hideOnSinglePage: true,
                                total: pagination?.totalRecords,
                                pageSize: pagination?.pageSize,
                                defaultPageSize: pagination?.pageSize,
                                current: pagination?.pageNo,
                                size: "default",
                                pageSizeOptions: ['10', '20', '50', '100'],
                                onChange: (pageNo, pageSize) => call(pageNo, pageSize),
                                showTotal: (total) => <Button className='brand-bg border0 text-white'>Total: {total}</Button>,
                            }}
                            loading = {
                                {
                                    ...TableLoader,
                                    spinning: loadingrev
                                }
                            }
                        />
                    </Col>
                </Row>
            </Card>
            <ReviewView 
                view={view}
                onClose={()=>{setVisible(false);setView(null)}}
            />
            <AlertModal
                visible={deleteitem}
                deleteitem={deleteitem}
                callBack={DeleteReviews}
                deletionLoading={deletionLoading}
                onClose={()=>{setDeleteItem(false)}}
            />
        </>
    )
}

export { ReviewPage }
